"use client";

import { format, startOfWeek, endOfWeek } from "date-fns";
import { Button } from "../button.js";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface WeekNavigationProps {
  currentDate: Date;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  onGoToToday: () => void;
  showNavigation?: boolean;
}

export function WeekNavigation({
  currentDate,
  onPreviousWeek,
  onNextWeek,
  onGoToToday,
  showNavigation = true,
}: WeekNavigationProps) {
  if (!showNavigation) {
    return null;
  }

  const weekStart = startOfWeek(currentDate);

  return (
    <div className="flex justify-between items-center mb-6">
      <Button variant="outline" onClick={onPreviousWeek}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="text-center">
        <h2 className="text-xl font-semibold">
          {format(weekStart, "MMM d")} - {format(endOfWeek(currentDate), "MMM d, yyyy")}
        </h2>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onGoToToday}>
          Today
        </Button>
        <Button variant="outline" onClick={onNextWeek}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
